<template>
	<!-- 8047: Disable sticker sparkles for now. -->
	<SparkleBox v-if="subTier > 0" class="mb-5" :spark="false">
		<v-card class="subscription-bar d-flex align-center justify-end px-4 py-1" :class="planClass">
			<strong class="fs--18 fw--900">{{ planName }} Subscriber</strong>
		</v-card>
	</SparkleBox>
</template>

<script>
import { computed } from '@vue/composition-api';
import store from '@/store';
import { SubPlan } from '@/utils/constants.js';
import SparkleBox from '@/components/SparkleBox.vue';

export default {
	components: {
		SparkleBox,
	},
	setup() {
		const subTier = computed(() => store.state.app.subTier);

		const planName = computed(() => {
			if (subTier.value === SubPlan.PREMIUM) {
				return `Premium`;
			} else if (subTier.value === SubPlan.PLUS) {
				return `Premium Plus`;
			} else if (subTier.value === SubPlan.EXTREME) {
				return `Premium Xtreme`;
			}
		});

		const planClass = computed(() => {
			if (subTier.value === SubPlan.PREMIUM) {
				return `premium`;
			} else if (subTier.value === SubPlan.PLUS) {
				return `plus`;
			} else if (subTier.value === SubPlan.EXTREME) {
				return `extreme`;
			}

			return 'free';
		});

		return {
			subTier,
			planName,
			planClass,
		};
	},
};
</script>

<style lang="scss">
.subscription-bar {
	width: 100%;

	&.premium {
		background: linear-gradient(to right, #a541ff, #40bbfe) !important;

		strong {
			color: #ffffff;
		}
	}

	&.plus {
		background: linear-gradient(to right, #a541ff, #ffff00) !important;

		strong {
			color: #333333;
		}
	}

	&.extreme {
		background: linear-gradient(to right, #a541ff, #ff01ff) !important;

		strong {
			color: #ffffff;
		}
	}
}
</style>
